import angular from 'angular'
import moment from 'moment-timezone'

import './top_prizes.service'
import './raffles/raffles.controller'

angular
  .module('pub.top_prizes', ['pub.top_prizes.service', 'pub.raffles'])
  .controller('TopPrizeCtrl', TopPrizeCtrl)

/** @ngInject */
function TopPrizeCtrl($scope, $stateParams, $state, TopPrizeService, UploadService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.pathImgThumb = ''

  vm.isOpen = false
  vm.isOpen2 = false

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.channelId = 0
  if ($stateParams.id) {
    vm.channelId = $stateParams.id
  } else if ($stateParams.channelId) {
    vm.channelId = $stateParams.channelId
  } else {
    vm.channelId = $stateParams.parentId
  }
  vm.channelId = parseInt(vm.channelId)

  function reloadPaginationInactive() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationActive() {
    vm.totalUsers2 = 0
    vm.perPage2 = 25
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalUsers3 = 0
    vm.perPage3 = 25
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  var tab = localStorage.getItem('tabtopprizes')
  if (tab !== null) {
    if (tab === 'active') {
      $('#inactive').removeClass('active')
      $('#active').addClass('active')
      $('#activetab').addClass('active')
      $('#archived').removeClass('active')
    } else {
      $('#active').removeClass('active')
      $('#inactive').addClass('active')
      $('#inactivetab').addClass('active')
      $('#archived').removeClass('active')
    }
  } else {
    $('#active').addClass('active')
    $('#activetab').addClass('active')
  }

  reloadPaginationActive()
  reloadPaginationInactive()
  reloadPaginationArchived()
  loadActive(1)
  loadInactive(1)
  loadArchived(1)

  function loadInactive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    TopPrizeService.listUnpublishedBychannel(vm.channelId, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsInactive = result.results
    })
  }

  function loadActive(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    TopPrizeService.listPublishedBychannel(vm.channelId, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsActive = result.results
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    TopPrizeService.listExpiredBychannel(vm.channelId, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsArchived = result.results
    })
  }

  vm.load = function (page) {
    reloadPaginationActive()
    reloadPaginationInactive()
    reloadPaginationArchived()
    loadActive(page)
    loadInactive(page)
    loadArchived(page)
  }

  vm.tabInactive = function () {
    $('#active').removeClass('active')
    $('#inactive').addClass('active')
    $('#archived').removeClass('active')
    localStorage.setItem('tabtopprizes', 'inactive')
  }

  vm.tabActive = function () {
    $('#inactive').removeClass('active')
    $('#active').addClass('active')
    $('#archived').removeClass('active')
    localStorage.setItem('tabtopprizes', 'active')
  }

  vm.tabArchived = function () {
    $('#inactive').removeClass('active')
    $('#active').removeClass('active')
    $('#archived').addClass('active')
    localStorage.setItem('tabtopprizes', 'archived')
  }

  vm.pageChangeInactive = function (newPage) {
    vm.sortType = oldSortType
    loadInactive(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangeActive = function (newPage) {
    vm.sortType2 = oldSortType2
    loadActive(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangeArchived = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.add = function () {
    vm.app = {
      id: 0,
      img: '',
      'id-ch': vm.channelId,
      t: '',
      url: '',
      'ts-start': null,
      'ts-end': null,
      n: 0,
    }
    $('#myModalAdd').modal('show')
  }

  vm.edit = function (item) {
    vm.app = angular.copy(item)
    delete vm.app.ts
    delete vm.app['ts-m']

    if (vm.app['ts-start']) {
      vm.app['ts-start'] = vm.app['ts-start'] / 1000
      vm.app['ts-start'] = new Date(parseInt(vm.app['ts-start']))
      vm.data1 = angular.copy(vm.app['ts-start'])
    }

    if (vm.app['ts-end']) {
      vm.app['ts-end'] = vm.app['ts-end'] / 1000
      vm.app['ts-end'] = new Date(parseInt(vm.app['ts-end']))
      vm.data2 = angular.copy(vm.app['ts-end'])
    }

    $('#myModalAdd').modal('show')
  }

  vm.create = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-start'] = date
      } else {
        vm.app['ts-start'] = null
      }
    } else {
      vm.app['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        vm.app['ts-end'] = date
      } else {
        vm.app['ts-start'] = null
      }
    } else {
      vm.app['ts-end'] = null
    }

    vm.app.n = parseInt(vm.app.n)

    TopPrizeService.save(vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        vm.load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function () {
    if (!vm.app.t) {
      swal('Please enter a Title', '', 'error')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-start'] = date
      } else {
        vm.app['ts-start'] = null
      }
    } else {
      vm.app['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        vm.app['ts-end'] = date
      } else {
        vm.app['ts-start'] = null
      }
    } else {
      vm.app['ts-end'] = null
    }

    vm.app.n = parseInt(vm.app.n)

    TopPrizeService.update(vm.app.id, vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        vm.load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          TopPrizeService.remove(item.id).then(
            function () {
              $('#myModalAdd').modal('hide')
              vm.load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.uploadThumb = function (item) {
    if (vm.pathImgThumb.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    let newId = Math.floor(Math.random() * 1000000)
    if (item.id) {
      newId = item.id
    }

    vm.loadThumb = true
    UploadService.save('top_prizes', vm.pathImgThumb, 'img', newId).then(function (fileName) {
      vm.loadThumb = false
      item['img'] = fileName
    })
  }

  vm.ruffles = function (item) {
    $state.go('pub.channels.top_prizes.raffles', { parentId: vm.channelId, topPrizeId: item.id })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })
}
